export const USER_FILTERS = {
  TYPE_OPTIONS: [
    {
      label: "All",
      value: "",
    },
    {
      label: "IT",
      value: "IT",
    },
    {
      label: "Support",
      value: "S",
    },
    {
      label: "Sales Person",
      value: "SP",
    },
    {
      label: "Sales Admin",
      value: "SA",
    },
    {
      label: "Internal Teams",
      value: "D",
    },
    {
      label: "Client Services",
      value: "CS",
    },
    {
      label: "Implementation Team",
      value: "I",
    },
    {
      label: "Implementation Manager",
      value: "M",
    },
    {
      label: "Client Services Manager",
      value: "CSM",
    },
  ],

  ACTIVE_OPTIONS: [
    {
      label: "All",
      value: "",
    },
    {
      label: "Yes",
      value: "Y",
    },
    {
      label: "No",
      value: "N",
    },
  ],
  USER_TYPE_OPTIONS: [
    {
      label: "All",
      value: "",
    },
    {
      label: "IT",
      value: "IT",
    },
    {
      label: "Support",
      value: "S",
    },
    {
      label: "Sales Person",
      value: "SP",
    },
    {
      label: "Sales Admin",
      value: "SA",
    },
    {
      label: "Internal Teams",
      value: "D",
    },
    {
      label: "Client Services",
      value: "CS",
    },
    {
      label: "Implementation Team",
      value: "I",
    },
    {
      label: "Implementation Manager",
      value: "M",
    },
    {
      label: "Client Services Manager",
      value: "CSM",
    },
  ],

  TIMES_OPTIONS: [
    {
      label: "AM",
      value: "AM",
    },
    {
      label: "PM",
      value: "PM",
    },
  ],
  TASK_TYPE_OPTIONS: [
    {
      label: "-Select-",
      value: "",
    },
    {
      label: "Training",
      value: "T",
    },
    {
      label: "Internal",
      value: "I",
    },
    {
      label: "Recurring",
      value: "R",
    },
  ],
  PRIORITY_OPTIONS: [
    {
      label: "Low",
      value: "Low",
    },
    {
      label: "Medium",
      value: "Medium",
    },
    {
      label: "High",
      value: "High",
    },
    {
      label: "Critical",
      value: "Critical",
    },
  ],
};
